import { render, staticRenderFns } from "./CaseListing.vue?vue&type=template&id=1a644c57"
import script from "./CaseListing.vue?vue&type=script&lang=js"
export * from "./CaseListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports